import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';
import ListIcon from '@material-ui/icons/List';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import DraftsOutlinedIcon from '@material-ui/icons/DraftsOutlined';
import LocalOfferOutlinedIcon from '@material-ui/icons/LocalOfferOutlined';
import ContactSupportOutlinedIcon from '@material-ui/icons/ContactSupportOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import RestaurantMenuOutlinedIcon from '@material-ui/icons/RestaurantMenuOutlined';
import FastfoodOutlinedIcon from '@material-ui/icons/FastfoodOutlined';
import BallotOutlinedIcon from '@material-ui/icons/BallotOutlined';
import EmojiSymbolsOutlinedIcon from '@material-ui/icons/EmojiSymbolsOutlined';
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import ComputerOutlinedIcon from '@material-ui/icons/ComputerOutlined';
import PaymentOutlinedIcon from '@material-ui/icons/PaymentOutlined';
import AccountBalanceOutlinedIcon from '@material-ui/icons/AccountBalanceOutlined';
import AttachMoneyOutlinedIcon from '@material-ui/icons/AttachMoneyOutlined';

const routes = [
    {
        name: 'Dashboard',
        path: 'dashboard',
        totalCountField: 'dashboard',
        icon: PersonOutlineOutlinedIcon,
        isDisabled: false,
        childRoutes: ['/dashboard']
    },
    {
        name: 'Users',
        path: 'users',
        totalCountField: 'users',
        icon: PersonOutlineOutlinedIcon,
        isDisabled: false,
        childRoutes: ['/userDetails']
    },
    {
        name: 'Chefs/Restaurants',
        path: 'restaurants',
        totalCountField: 'chefsAndResturants',
        isDisabled: false,
        icon: RestaurantMenuOutlinedIcon
    },
    {
        name: 'Payments',
        path: 'payments',
        totalCountField: 'payments',
        icon: PaymentOutlinedIcon,
        isDisabled: false,
    },
    // {
    //     name: 'Verify Payments',
    //     path: 'verify-payment',
    //     totalCountField: 'verifyPayments',
    //     icon: DraftsOutlinedIcon,
    //     isDisabled: false,
    // },
    {
        name: 'Orders',
        path: 'orders',
        totalCountField: 'orders',
        icon: BallotOutlinedIcon,
        isDisabled: false,
    },
    // {
    //     name: 'Dashboard',
    //     path: 'dashboard',
    //     icon: DashboardOutlinedIcon,
    //     isDisabled: true
    // },
    // {
    //     name: 'Wallet',
    //     path: 'wallet',
    //     icon: AccountBalanceWalletOutlinedIcon,
    //     isDisabled: true,
    // },
    // {
    //     name: 'Food Items',
    //     path: 'fooditems',
    //     icon: FastfoodOutlinedIcon,
    //     isDisabled: true,
    // },
    // {
    //     name: 'Manage Categories',
    //     path: 'categories',
    //     icon: ListIcon,
    //     isDisabled: true,
    // },
    // {
    //     name: 'Resolution Center',
    //     path: 'resolution',
    //     icon: MailOutlineIcon,
    //     isDisabled: true,
    // },
    // {
    //     name: 'Promo Codes',
    //     path: 'promocodes',
    //     icon: EmojiSymbolsOutlinedIcon,
    //     isDisabled: true,
    // },
    // {
    //     name: 'Newsletter',
    //     path: 'newsletters',
    //     icon: DraftsOutlinedIcon,
    //     isDisabled: true,
    // },
    // {
    //     name: 'Reports',
    //     path: 'reports',
    //     icon: AssessmentOutlinedIcon,
    //     isDisabled: true,
    // },
    // {
    //     name: 'Website Contents',
    //     path: 'webcontent',
    //     icon: ComputerOutlinedIcon,
    //     isDisabled: true,
    // },
    // {
    //     name: 'Manage Tags',
    //     path: 'tags',
    //     icon: LocalOfferOutlinedIcon,
    //     isDisabled: true,
    // },
    // {
    //     name: 'Enjoyfresh Margins',
    //     path: 'enjoyfreshmargins',
    //     icon: AttachMoneyOutlinedIcon,
    //     isDisabled: true,
    // },
    // {
    //     name: 'FAQs',
    //     path: 'faqs',
    //     icon: ContactSupportOutlinedIcon,
    //     isDisabled: true,
    // },
    // {
    //     name: 'Settings',
    //     path: 'settings',
    //     icon: SettingsOutlinedIcon,
    //     isDisabled: true,
    // },

    {
        name: 'Settlements',
        path: 'settlements',
        icon: AccountBalanceOutlinedIcon,
        isDisabled: false,
        items: [{
            name: 'Enjoyfresh Margins',
            path: 'enjoyfreshmargins',
            icon: AttachMoneyOutlinedIcon,
            isDisabled: false,
        }]
    },
    {
        name: 'Banners',
        path: 'banners',
        icon: ComputerOutlinedIcon,
        isDisabled: false,
    },
    {
        name: 'Categories',
        path: 'categories',
        icon: ComputerOutlinedIcon,
        isDisabled: false,
    },
    {
        name: 'Discounts',
        path: 'discounts',
        icon: SettingsOutlinedIcon,
        isDisabled: false,
    },
    {
        name: 'App Versions',
        path: 'app-versions',
        icon: SettingsOutlinedIcon,
        isDisabled: false,
    },
];

export default routes;